/* istanbul ignore file */
import { EnumDropdown, DefaultInputPropTypes, useInputHelper } from 'framework/form';
import { useDidUpdateEffect } from 'framework/utils';
import { ASSET_CATEGORIES_TYPES } from 'domain/finance/assets/useAssetService';

const AssetCategoryTypeDropdown = ({
  categorySource,
  source,
  ...props
}: DefaultInputPropTypes<string> & { categorySource: string }) => {
  const { getRawOnChangeCallback, getValue } = useInputHelper({ source });
  const { getValue: getCategory } = useInputHelper({ source: categorySource });
  const category = getCategory() as any;
  const options = ASSET_CATEGORIES_TYPES[category];
  const rawOnChangeCallback = getRawOnChangeCallback();
  const value = getValue();

  useDidUpdateEffect(() => {
    if (value && rawOnChangeCallback) {
      rawOnChangeCallback({ [source]: null });
    }
    // Suppressed warnings because we only need to call useEffect callback only after updating options
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return <EnumDropdown options={options || {}} {...props} source={source} />;
};

export default AssetCategoryTypeDropdown;
